var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHopefulIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1121 22.2735C52.1121 22.2735 51.837 16.9012 46.5607 15.1782C46.5607 15.1782 42.1339 13.7544 39.0352 18.0379C39.0352 18.0379 46.2855 14.58 52.1001 22.2735H52.1121Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9618 41.7166C50.0321 41.7166 53.3318 37.1739 53.3318 31.5702C53.3318 25.9665 50.0321 21.4238 45.9618 21.4238C41.8915 21.4238 38.5918 25.9665 38.5918 31.5702C38.5918 37.1739 41.8915 41.7166 45.9618 41.7166Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1967 37.1581C47.2319 37.1581 48.8817 34.8868 48.8817 32.0849C48.8817 29.2831 47.2319 27.0117 45.1967 27.0117C43.1615 27.0117 41.5117 29.2831 41.5117 32.0849C41.5117 34.8868 43.1615 37.1581 45.1967 37.1581Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7617 22.4782C17.7617 22.4782 17.8335 17.0939 23.038 15.1795C23.038 15.1795 27.4049 13.5882 30.6592 17.752C30.6592 17.752 23.2773 14.5693 17.7617 22.4782Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1618 31.5702C31.1618 37.1699 27.8597 41.7166 23.7918 41.7166C19.724 41.7166 16.4219 37.1699 16.4219 31.5702C16.4219 25.9706 19.724 21.4238 23.7918 21.4238C27.8597 21.4238 31.1618 25.9706 31.1618 31.5702Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.558 37.1581C26.5932 37.1581 28.243 34.8868 28.243 32.0849C28.243 29.2831 26.5932 27.0117 24.558 27.0117C22.5229 27.0117 20.873 29.2831 20.873 32.0849C20.873 34.8868 22.5229 37.1581 24.558 37.1581Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4612 46.1452C15.8311 46.1452 18.5629 44.1631 18.5629 41.7181C18.5629 39.2731 15.8311 37.291 12.4612 37.291C9.09124 37.291 6.35938 39.2731 6.35938 41.7181C6.35938 44.1631 9.09124 46.1452 12.4612 46.1452Z",
    fill: "#FF7EF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7053 46.1452C60.0752 46.1452 62.8071 44.1631 62.8071 41.7181C62.8071 39.2731 60.0752 37.291 56.7053 37.291C53.3354 37.291 50.6035 39.2731 50.6035 41.7181C50.6035 44.1631 53.3354 46.1452 56.7053 46.1452Z",
    fill: "#FF7EF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4416 55.873C41.2722 55.0833 47.2065 52.104 47.2902 46.5762C47.2902 46.5762 39.1066 53.1809 26.9629 53.5638C30.4206 57.8832 36.9411 56.579 38.8673 56.0764L39.4536 55.873H39.4416Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHopefulIcon);
export default __webpack_public_path__ + "static/media/hopeful-icon.1008bd03405722d808503635340a44ae.svg";
export { ForwardRef as ReactComponent };